import React from 'react';
import { Box, Typography } from '@mui/material';
import { StatusChip } from '../ui/StatusChip';
import { tokens } from '../../theme/tokens';
import { CopyProvenance, describeCopySource } from '../../utils/erpSyncAuditDisplay';

const toneFor = (source: string) =>
  source === 'store_override' ? 'info' : source === 'unknown' ? 'neutral' : 'positive';

/**
 * Where the title and description Motzu last pushed to the store's listing came from
 * (flag `copy_provenance`). Renders nothing for a mapping that carries no provenance.
 */
export function CopyProvenanceRow({ provenance }: { provenance?: CopyProvenance | null }) {
  const rows = [
    { key: 'title', name: 'Title from', field: provenance?.title },
    { key: 'description', name: 'Description from', field: provenance?.description },
  ].filter((r) => r.field);
  if (rows.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }} data-testid="copy-provenance">
      {rows.map(({ key, name, field }) => {
        const { label, detail } = describeCopySource(field!);
        return (
          <Box key={key} sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
            <Typography variant="caption" sx={{ color: tokens.ink.muted }}>{name}:</Typography>
            <StatusChip label={label} tone={toneFor(field!.source)} />
            {detail && <Typography variant="caption" sx={{ color: tokens.ink.muted }}>{detail}</Typography>}
            {field!.adapted && (
              <StatusChip label="Shortened to fit Shopify" tone="caution" variant="outlined" />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
